var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { grey } from '@material-ui/core/colors';
import SvgCamera from '@material-ui/icons/PhotoCamera';
import Paper from '@material-ui/core/Paper';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import InfiniteScroll from 'react-infinite-scroller';
import { getTranslate } from 'react-localize-redux';
import { Map, List as ImuList } from 'immutable';
// - Import app components
import { SuitePost } from 'src/components/post';
import PostWriteComponent from 'src/components/postWrite';
import UserAvatarComponent from 'src/components/userAvatar';
import LoadMoreProgressComponent from 'src/layouts/loadMoreProgress';
import * as postActions from 'src/store/actions/postActions';
// - Import API
import * as PostAPI from 'src/api/PostAPI';
// - Import actions
import * as globalActions from 'src/store/actions/globalActions';
import Sidenav from 'components/sidenav';
import * as moment from 'moment/moment';
import './stream.css';
import mystyles from 'assets/jss/material-dashboard-react/views/dashboardStyle.js';
// import makeStyles from '@material-ui/core/styles/makeStyles'
import { withStyles } from '@material-ui/core';
// var background = require('../../containers/home/possibleBackgrounds/Ice1.jpg')
// - Create StreamComponent component class
var Iceshirt = require('../../assets/Models/ice.glb');
var Months = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec'
};
var Mystyles = function (theme) { return (mystyles); };
var StreamComponent = /** @class */ (function (_super) {
    __extends(StreamComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function StreamComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            postWritePrimaryText: {
                color: grey[400],
                cursor: 'text'
            },
            postWtireItem: {
                fontWeight: '200'
            },
            primaryImage: {
                backgroundImage: "url(https://firebasestorage.googleapis.com/v0/b/fileupload-test-93e98.appspot.com/o/WebsiteFileControl%2Fhome.jpg?alt=media&token=1ef058d6-ea40-4362-89e8-0c9b18b2b644)",
                backgroundAttachment: 'fixed',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100%',
                height: '720px',
            }
        };
        _this.freq = Map();
        _this.totalRevenue = 0;
        /**
         * Open post write
         *
         *
         * @memberof StreamComponentF
         */
        _this.handleOpenPostWrite = function () {
            _this.setState({
                openPostWrite: true
            });
        };
        /**
         * Close post write
         *
         *
         * @memberof StreamComponent
         */
        _this.handleClosePostWrite = function () {
            _this.setState({
                openPostWrite: false
            });
        };
        /**
         * Create a list of posts
         * @return {DOM} posts
         */
        _this.postLoad = function () {
            var match = _this.props.match;
            var posts = _this.props.posts;
            var tag = match.params.tag;
            if (posts === undefined || !(posts.keySeq().count() > 0)) {
                return (React.createElement("h1", null, "'Nothing has shared.'"));
            }
            else {
                var postBack_1 = { divided: false, oddPostList: [], evenPostList: [], threePostList: [], fourPostList: [] };
                var parsedPosts_1 = ImuList();
                posts.forEach(function (post) {
                    // total += itemSales.size
                    if (tag) {
                        var regex = new RegExp('#' + tag, 'g');
                        var postMatch = String(post.get('body', '')).match(regex);
                        if (postMatch !== null) {
                            parsedPosts_1 = parsedPosts_1.push(post);
                        }
                    }
                    else {
                        parsedPosts_1 = parsedPosts_1.push(post);
                    }
                });
                var sortedPosts = PostAPI.sortImuObjectsDate(parsedPosts_1);
                if (sortedPosts.count() > -1) {
                    postBack_1.divided = true;
                }
                else {
                    postBack_1.divided = false;
                }
                var index_1 = 1;
                var one = 1;
                var two = 2;
                var three = 3;
                var four = 4;
                var total = 0;
                sortedPosts.forEach(function (post) {
                    var newPost = (React.createElement("div", { onClick: function () { return _this.getProductSales(post); }, key: post.get('id') + "-stream-div" },
                        index_1 > 0 || (!postBack_1.divided && index_1 > 0) ? React.createElement("div", { style: { height: '16px' } }) : '',
                        React.createElement(SuitePost, { key: post.get('id') + "-stream-div-post", post: post })));
                    if (index_1 === 0 && postBack_1.divided) {
                        postBack_1.oddPostList.push(newPost);
                    }
                    if (index_1 === one && postBack_1.divided) {
                        one += 4;
                        postBack_1.evenPostList.push(newPost);
                    }
                    if (index_1 === two && postBack_1.divided) {
                        postBack_1.oddPostList.push(newPost);
                        two += 4;
                    }
                    if (index_1 === three && postBack_1.divided) {
                        postBack_1.threePostList.push(newPost);
                        three += 4;
                    }
                    if (index_1 === four && postBack_1.divided) {
                        four += 4;
                        postBack_1.fourPostList.push(newPost);
                    }
                    ++index_1;
                });
                return postBack_1;
            }
        };
        /**
         * Scroll loader
         */
        _this.scrollLoad = function (page) {
            var loadStream = _this.props.loadStream;
            loadStream(page, 4);
        };
        _this.getTotalRevenue = function () {
            _this.postLoad();
            console.log('POOOOST', _this.state.LoadedPosts);
        };
        _this.getProductSales = function (product) {
            _this.setState({ currentPost: product });
            console.log(_this.state.currentPost);
            var sales = product.get('sales');
            sales.size ? _this.setState({ ItemSales: sales.size }) : _this.setState({ ItemSales: 0 });
            console.log('len', sales);
            sales.forEach(function (sale) {
                console.log('sallysalwe', sale);
            });
            _this.getSaleData(sales);
        };
        _this.getSaleData = function (sales) {
            sales.forEach(function (sale) {
                var saleDate = sale.get('creationDate');
                var month = moment.unix(saleDate).format('M');
                // var month = readdate.getDate()
                var MonthName = Months[month];
                _this.freq[MonthName]++;
            });
            console.log('frequency', _this.freq);
        };
        // getNetSales = () => {
        //   let gross = (parseFloat(this.state.currentPost!.get('price')) * this.state.ItemSales)
        //   let net = gross - (gross * .15)
        //   return net
        // }
        _this.getNetSales = function (price, sales) {
            var gross = parseFloat(price) * sales;
            var net = gross - (gross * .15);
            return net;
        };
        _this.getBestMonth = function () {
            var gross = (parseFloat(_this.state.currentPost.get('price')) * _this.state.ItemSales);
            var net = gross - (gross * .15);
            return net;
        };
        _this.state = {
            /**
             * It's true if we want to have two column of posts
             */
            divided: false,
            /**
             * If it's true comment will be disabled on post
             */
            disableComments: _this.props.disableComments,
            /**
             * If it's true share will be disabled on post
             */
            disableSharing: _this.props.disableSharing,
            /**
             * If it's true, post write will be open
             */
            openPostWrite: false,
            /**
             * The title of home header
             */
            homeTitle: props.homeTitle,
            /**
             * If there is more post to show {true} or not {false}
             */
            hasMorePosts: true,
            currentPost: Map({}),
            ItemSales: 0,
            TotalSales: 0,
            TotalRevenue: 0,
            LoadedPosts: _this.props.Loadedposts
        };
        // Binding functions to `this`
        _this.postLoad = _this.postLoad.bind(_this);
        _this.handleOpenPostWrite = _this.handleOpenPostWrite.bind(_this);
        _this.handleClosePostWrite = _this.handleClosePostWrite.bind(_this);
        _this.getProductSales = _this.getProductSales.bind(_this);
        _this.getNetSales = _this.getNetSales.bind(_this);
        return _this;
    }
    StreamComponent.prototype.componentDidMount = function () {
        var _this = this;
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Oct', 'Nov', 'Dec'];
        months.forEach(function (month) {
            _this.freq[month] = 0;
        });
        this.getTotalRevenue();
        console.log('local', this.props.Loadedposts);
    };
    StreamComponent.prototype.componentWillMount = function () {
        var _a = this.props, setHomeTitle = _a.setHomeTitle, loadStream = _a.loadStream;
        setHomeTitle();
    };
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    StreamComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, tag = _a.tag, displayWriting = _a.displayWriting, hasMorePosts = _a.hasMorePosts, translate = _a.translate, classes = _a.classes;
        var postList = this.postLoad();
        var dates = Object.keys(this.freq);
        var vals = [];
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Oct', 'Nov', 'Dec'];
        months.forEach(function (month) {
            vals.push(_this.freq[month]);
        });
        var data = {
            labels: months,
            datasets: [
                {
                    label: 'Sales',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'grey',
                    color: 'grey',
                    borderColor: '#efefef',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: vals,
                    borderWidth: .4,
                    labels: {
                        font: {
                            color: 'grey',
                        }
                    }
                },
            ]
        };
        // console.warn('data', data)
        if (window.outerWidth > 500) {
            return (React.createElement(InfiniteScroll, { pageStart: 0, loadMore: this.scrollLoad, hasMore: hasMorePosts, useWindow: true, loader: React.createElement(LoadMoreProgressComponent, { key: 'stream-load-more-progress' }) },
                this.state.currentPost.get('DesignName') ?
                    React.createElement("div", { className: 'infoGrid' },
                        React.createElement("div", { className: 'gridEl', style: { maxWidth: '100%' } },
                            React.createElement("div", { style: { textAlign: 'center', fontWeight: 'bold' } },
                                " ",
                                this.state.currentPost.get('DesignName'),
                                " Info:"),
                            React.createElement("div", { style: { textAlign: 'left' } },
                                " ",
                                this.state.currentPost ? "Total Amount of Sales: " + this.state.ItemSales : ''),
                            React.createElement("div", { style: { textAlign: 'left' } },
                                " ",
                                this.state.currentPost ? "Net Total : $" + this.getNetSales(this.state.currentPost.get('price'), this.state.ItemSales) : ''),
                            React.createElement("div", { style: { textAlign: 'left' } },
                                " ",
                                this.state.currentPost ? "Date Released: " + moment.unix(this.state.currentPost.get('creationDate')).format('MM/DD/YYYY') : '')),
                        React.createElement("img", { className: 'gridEl', style: { maxWidth: '100%' }, src: this.state.currentPost.get('image') }),
                        React.createElement("div", { className: 'gridEl', style: { maxWidth: '100%' } },
                            React.createElement("div", null, " Inventory Remaining:  "),
                            React.createElement("div", null, " Small: 7 "),
                            React.createElement("div", null, " Medium: 4 "),
                            React.createElement("div", null, " Large: 11 ")))
                    :
                        React.createElement("div", null,
                            "Total ",
                            this.state.TotalSales),
                React.createElement("div", { style: {} }, displayWriting && !tag
                    ? (React.createElement("div", { style: { display: 'block', textAlign: 'center', width: '50%', margin: 'auto', marginTop: '7%' } }, this.props.isDesigner ?
                        React.createElement(PostWriteComponent, { open: this.state.openPostWrite, onRequestClose: this.handleClosePostWrite, edit: false },
                            React.createElement(Paper, { elevation: 2 },
                                React.createElement(ListItem, { button: true, style: this.styles.postWtireItem, onClick: this.handleOpenPostWrite },
                                    React.createElement(UserAvatarComponent, { fullName: this.props.fullName, fileName: this.props.avatar, size: 36 }),
                                    React.createElement(ListItemText, { inset: true, primary: React.createElement("span", { style: this.styles.postWritePrimaryText },
                                            " ",
                                            translate('home.postWriteButtonText')) }),
                                    React.createElement(ListItemIcon, null,
                                        React.createElement(SvgCamera, null)))),
                            React.createElement("div", { style: { height: '16px' } }))
                        : ''))
                    : ''),
                this.props.Main ?
                    React.createElement("div", { style: { marginBottom: '.3%', textAlign: 'center' } },
                        React.createElement("div", { style: { fontFamily: 'ivymode, sans-serif', fontSize: '2.2rem', letterSpacing: '.10em', marginLeft: 'auto', textAlign: 'center' } }, this.props.Main),
                        React.createElement("div", { style: { fontFamily: 'ivymode, sans-serif', letterSpacing: '.10em', fontSize: '1.1rem' } }, this.props.Secondary)) : React.createElement("div", null, " "),
                React.createElement("div", null,
                    this.props.Profile ? React.createElement("div", null, " ") // ensure we are not on profile page
                        :
                            React.createElement("div", { style: { float: 'left' } },
                                React.createElement(Sidenav, null)),
                    React.createElement("div", { className: 'grid grid__gutters grid__1of4 grid__space-around animate-top', style: this.props.Profile ?
                            { margin: 'auto', padding: '40px', paddingTop: '5px', marginLeft: '0' } : // style based on whether we are on a profile or not
                            { margin: 'auto', padding: '40px', paddingTop: '5px', marginLeft: '13%' } },
                        React.createElement("div", { className: 'grid-cell animate-top', style: { maxWidth: '25%', minWidth: '260px', verticalAlign: 'top' } },
                            postList.evenPostList,
                            React.createElement("div", { style: { height: '16px' } })),
                        postList.divided
                            ? (React.createElement("div", { className: 'grid-cell animate-top', style: { maxWidth: '25%', minWidth: '250px', verticalAlign: 'top' } },
                                postList.oddPostList,
                                React.createElement("div", { style: { height: '16px' } })))
                            : '',
                        postList.divided
                            ? (React.createElement("div", { className: 'grid-cell animate-top', style: { maxWidth: '25%', minWidth: '250px', verticalAlign: 'top' } },
                                postList.threePostList,
                                React.createElement("div", { style: { height: '16px' } })))
                            : '',
                        postList.divided
                            ? (React.createElement("div", { className: 'grid-cell animate-top', style: { maxWidth: '25%', minWidth: '250px', verticalAlign: 'top' } },
                                postList.fourPostList,
                                React.createElement("div", { style: { height: '16px' } })))
                            : ''))));
        }
        return (React.createElement(InfiniteScroll, { pageStart: 0, loadMore: this.scrollLoad, hasMore: hasMorePosts, useWindow: true, loader: React.createElement(LoadMoreProgressComponent, { key: 'stream-load-more-progress' }) },
            React.createElement("div", null, displayWriting && !tag
                ? (React.createElement("div", { style: { display: 'block', textAlign: 'center', width: '75%', margin: 'auto', marginTop: '1%', backgroundColor: '' } },
                    React.createElement(PostWriteComponent, { open: this.state.openPostWrite, onRequestClose: this.handleClosePostWrite, edit: false },
                        React.createElement(Paper, { elevation: 2 },
                            React.createElement(ListItem, { button: true, style: this.styles.postWtireItem, onClick: this.handleOpenPostWrite },
                                React.createElement(UserAvatarComponent, { fullName: this.props.fullName, fileName: this.props.avatar, size: 36 }),
                                React.createElement(ListItemText, { inset: true, primary: React.createElement("span", { style: this.styles.postWritePrimaryText },
                                        " ",
                                        translate('home.postWriteButtonText')) }),
                                React.createElement(ListItemIcon, null,
                                    React.createElement(SvgCamera, null)))),
                        React.createElement("div", { style: { height: '16px' } })),
                    React.createElement("div", { style: { marginTop: '5%', marginBottom: '10%', textAlign: 'center' } },
                        React.createElement("div", { style: { fontFamily: 'Carrois Gothic SC, sans-serif', fontSize: '2.2rem', letterSpacing: '.10em', marginLeft: 'auto', textAlign: 'center' } }, "New Arrivals"),
                        React.createElement("div", { style: { fontFamily: 'Carrois Gothic SC, sans-serif', letterSpacing: '.10em', fontSize: '1.1rem' } }, "Discover artists from around the globe"))))
                : ''),
            React.createElement("div", { className: 'grid grid__gutters grid__1of3 grid__space-around animate-top' },
                React.createElement("div", { className: 'grid-cell animate-top', style: { maxWidth: '30%', minWidth: '350px', margin: 'auto' } },
                    postList.evenPostList,
                    React.createElement("div", { style: { height: '16px' } })),
                postList.divided
                    ? (React.createElement("div", { className: 'grid-cell animate-top', style: { maxWidth: '30%', minWidth: '350px' } },
                        postList.oddPostList,
                        React.createElement("div", { style: { height: '16px' } })))
                    : '',
                postList.divided // min width = size on iphone
                    ? (React.createElement("div", { className: 'grid-cell animate-top', style: { maxWidth: '30%', minWidth: '350px', marginTop: '-15px' } },
                        postList.threePostList,
                        React.createElement("div", { style: { height: '16px' } })))
                    : '')));
    };
    StreamComponent.propTypes = {
        /**
         * If it's true , writing post block will be visible
         */
        displayWriting: PropTypes.bool.isRequired,
        /**
         * A list of post
         */
        posts: PropTypes.object,
        /**
         * The title of home header
         */
        homeTitle: PropTypes.string
    };
    return StreamComponent;
}(Component));
export { StreamComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    var userId = ownProps.match.params.userId;
    return {
        setHomeTitle: function () { return dispatch(globalActions.setHeaderTitle(ownProps.homeTitle || '')); },
        showTopLoading: function () { return dispatch(globalActions.showTopLoading()); },
        hideTopLoading: function () { return dispatch(globalActions.hideTopLoading()); },
        loadPosts: function () { return dispatch(postActions.dbGetPostsByUserId(userId)); },
    };
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    var uid = state.getIn(['authorize', 'uid']);
    var user = state.getIn(['user', 'info', uid]);
    var Loadedposts = state.getIn(['post', 'userPosts', uid]);
    var Scene = state.getIn(['renderer', 'StateScene']);
    var Camera = state.getIn(['renderer', 'StateCamera']);
    console.log('loaded', Loadedposts);
    return {
        translate: getTranslate(state.get('locale')),
        posts: Loadedposts,
        Loadedposts: Loadedposts,
        avatar: user ? user.avatar : '',
        fullName: user ? user.fullName : '',
        isDesigner: user ? user.isDesigner : false,
        Scene: Scene,
        Camera: Camera
    };
};
// - Connect component to redux store
// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StreamComponent as any) as any) as typeof StreamComponent
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(Mystyles, { withTheme: true })(StreamComponent)));



//////////////////
// WEBPACK FOOTER
// ./src/containers/stream/SuiteStream.tsx
// module id = 1572
// module chunks = 1 6 21 23